var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 408 408",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 94 393 C 82 393 75 386 75 374 L 75 177 C 75 153 93 135 119 135 125 134 132 135 139 135 149 134 156 128 156 117 156 114 156 110 156 106 156 95 151 88 139 87 129 87 123 80 123 71 124 65 124 59 126 53 134 31 151 17 175 16 195 15 216 15 237 16 264 18 286 43 286 71 286 80 279 87 270 87 258 88 253 95 253 107 253 110 253 114 253 118 253 128 260 134 270 135 277 135 283 134 290 135 316 135 333 153 333 178 L 333 322 C 333 339 333 357 333 374 333 386 326 393 315 393 L 205 393 94 393 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.0ecd8bf7ab2e0b718d29de9b4643c6cc.svg";
export { ForwardRef as ReactComponent };